<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>Publicidad ActivoTrade Foro</h2>
      <p class="description">Configura quién ve la publicidad de ActivoTrade en el foro</p>
    </div>

    <div class="control-section">
      <label for="forum-activo-banner-mode">Visibilidad:</label>
      <select id="forum-activo-banner-mode" v-model="forumActivoBannerMode" class="admin-select">
        <option value="all">Todos</option>
        <option value="selected">Seleccionados</option>
        <option value="none">Nadie</option>
      </select>
      <p class="help-text">Seleccionados mantiene la lista actual de usuarios configurada en el frontend.</p>
    </div>

    <div class="action-section">
      <button @click="saveSettings" class="btn-primary" :disabled="saving">
        {{ saving ? 'Guardando...' : 'Guardar Configuración' }}
      </button>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ForumActivoBannerSettingsTab',
  data() {
    return {
      forumActivoBannerMode: 'selected',
      saving: false,
      message: '',
      messageType: ''
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/forum-activo-banner-mode`);
        if (response.data.success) {
          this.forumActivoBannerMode = response.data.value || 'selected';
        }
      } catch (error) {
        console.error('Error loading ActivoTrade forum banner settings:', error);
      }
    },
    async saveSettings() {
      this.saving = true;
      this.message = '';

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/forum-activo-banner-mode/${this.forumActivoBannerMode}`);

        if (response.data.success) {
          this.message = 'Configuración guardada correctamente';
          this.messageType = 'success';

          setTimeout(() => {
            this.message = '';
          }, 3000);
        } else {
          this.message = response.data.message || 'Error al guardar la configuración';
          this.messageType = 'error';
        }
      } catch (error) {
        this.message = 'Error al guardar la configuración';
        this.messageType = 'error';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.control-section {
  margin-bottom: 20px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  width: 100%;
  max-width: 300px;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  margin-top: 5px;
}

.action-section {
  margin-top: 20px;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: background 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-box {
  margin-top: 20px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.message-box.success {
  background-color: #27ae60;
  color: white;
}

.message-box.error {
  background-color: #e74c3c;
  color: white;
}
</style>
